module.exports = __webpack_public_path__ + "static/media/shield-impact.54fdc5c4.svg";